import { CommonModule } from '@angular/common';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { NavigationService } from 'src/app/core/service/navigation.service';
import { RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { UrlServices } from 'src/app/helper/class/url-services';
import { cloneData, isArray } from 'src/app/helper/class/utilityHelper';
import { pageInfo } from 'src/app/helper/interface/menu-interface';
import { ResponseData, formBuilderData, tableAction, tableBuilder, tableButton, tblFilterQuery } from 'src/app/helper/interface/response';
import { AlertService } from 'src/app/helper/service/alert.service';
import { FeatureModalModule } from 'src/app/shared/feature-modal/feature-modal.module';
import { PrintDocComponent } from 'src/app/shared/feature-modal/print-doc/print-doc.component';
import { FormGeneratorComponent } from 'src/app/shared/form/component/form-generator/form-generator.component';
import { TableListComponent } from 'src/app/shared/form/component/table-list/table-list.component';
import { FormHelperModule } from 'src/app/shared/form/form-hepler.module';
import { ModalService } from 'src/app/shared/service/modal.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { INVOICEADD_LIST, INVOICE_ADD_LIST_MAIN, INVOICE_TBL_FORM } from '../../helper/invoice-form';
import { InvoiceApiService } from '../../service/invoice-api.service';
import { PatientsService } from 'src/app/modules/patients/service/patients.service';
import { AuthService } from 'src/app/helper/service/auth.service';

@Component({
  selector: 'app-invoice-view',
  templateUrl: './invoice-view.component.html',
  styleUrl: './invoice-view.component.scss',
  standalone: true,
  imports: [FormHelperModule, FeatureModalModule, CommonModule, ReactiveFormsModule, SharedModule]
})
export class InvoiceViewComponent implements OnInit {
  basicFormData1: formBuilderData[] = cloneData(INVOICE_ADD_LIST_MAIN);
  pageInfo: pageInfo = { title: ' Add Invoice Details' }
  invoice_date = new Date().toISOString();
  isModal: boolean = false
  invoiceId: any;
  invoiceData: any;
  loadingData: boolean = false;
  paymentForm: FormGroup = {} as FormGroup
  basicFormData: formBuilderData[] = cloneData(INVOICEADD_LIST);
  @ViewChild('basicForm') basicForm: FormGeneratorComponent | undefined;
  @ViewChild('tableData') tableData: TableListComponent | undefined;
  subBtn: boolean = false;
  treatmentList: any = [];
  totalAmount: any = 0
  totalPaid: any
  discountAmount: any = 0;
  overallAmount: any = 0;
  finalAmount: any = 0;
  finalViewAmount: any = 0;
  dueAmount: any = 0;
  balanceAmt: any = 0
  paidShowBtn: any;
  paymentMade: any = 0;
  paymentShow: any = 0;
  paymentData: any = [];
  amount: number = 0;
  LIST_COL: any = INVOICE_TBL_FORM;
  actionBtn: tableButton[] = [
    {
      name: '',
      class: 'btn-danger',
      icon: 'las la-trash',
      title: 'Staff Relieve',
      type: 'DELETE',
    }, // permission: { moduleName: 'STAFF', actionName: 'RELIVE' } }
  ];
  tableConfig: tableBuilder = {
    name: 'Staff list',
    column: this.LIST_COL,
    action: this.actionBtn,
    isLazy: true,
  };
  _bsModalRef: BsModalRef = {} as BsModalRef;
  mode: 'VIEW' | 'EDIT' = 'VIEW'
  public onClose: Subject<{ reload: boolean }> = new Subject();
  dueAmountRemain: any;
  theme_color = this.auth.currentSettingValue?.theme_color || '#a5bdfd';
  constructor(private invoiceApi: InvoiceApiService,
    private alertService: AlertService,
    private activatedRoute: ActivatedRoute,
    private injector: Injector,
    private navServe: NavigationService,
    private modalService: ModalService,
    private patientApi: PatientsService,
    private router: Router, private auth: AuthService) { }
  ngOnInit(): void {
    this.invoiceId = this.activatedRoute.snapshot.queryParams['id'] || '';
    this.mode = this.activatedRoute.snapshot.queryParams['mode'] || 'VIEW';
    if (this.mode == 'VIEW') {
      this.tableConfig.action = [];
      this.pageInfo.title = 'Invoice Info';
    }
    if (this.mode === 'EDIT' && this.invoiceId) {
      this.pageInfo.title = 'Update Invoice Details';
    }
    this.initForm();
    if (this.invoiceId) {
      this.getInvoicePayment();
      this.getInvoiceData(this.invoiceId);
    }
  }
  initForm() {
    this.paymentForm = new FormGroup({
      discount: new FormControl(0),
      payment: new FormControl(0),
      payment_date: new FormControl(this.formatDateForInput(new Date())),
    })
  }

  setInput(data: any) {
    this.isModal = true
    if (data.mode) {
      this.mode = data.mode;
    }
    if (this.mode == 'VIEW') {
      this.tableConfig.action = [];
    }
    this._bsModalRef = this.injector.get<BsModalRef>(BsModalRef);
    if (data.id) {
      // this.invoiceId = '';
      this.getInvoicePayment();
      this.getInvoiceData(data.id)
    }
    //  else if (data.invoice_fk_id) {
    //   this.invoiceId = data.invoice_fk_id;
    //   this.getInvoiceData(data.invoice_fk_id)
    // }
  }
  pendingAmount: any;

  getInvoiceData(id: any) {
    console.log('invoice id', id);
    if (id) {
      this.loadingData = true;
      const API = this.invoiceId
        ? this.invoiceApi.getDetails(id)
        : this.invoiceApi.paymentPendingDetails(id);

      API.then((res: ResponseData | any) => {
        if (res?.statusCode == RESPONSE_CODE.SUCCESS) {
          this.invoiceData = res.result;

          if (this.invoiceData.invoice_date) {
            this.invoice_date = this.invoiceData.invoice_date;
          }

          this.paymentForm.patchValue({
            discount: this.invoiceData.discount || 0,
            payment: 0,
            payment_date: this.formatDateForInput(this.invoiceData.payment_date || (this.mode === 'EDIT' ? new Date() : ''))
          });

          this.discountAmount = this.invoiceData.discount || 0;

          this.treatmentList = [];
          if (isArray(this.invoiceData.item)) {
            this.invoiceData.item.forEach((e: any) => {
              this.treatmentList.push({
                id: e.id || '',
                amount: e.amount,
                description: e.description,
                patient_treatment_id: e.patient_treatment_id,
                treatment_fk_id: e.treatment_fk_id
              });
            });

            this.amount = this.treatmentList.reduce((sum, treatment) => {
              return sum + parseInt(treatment.amount);
            }, 0);
          }

          this.tableData?.reload();
          this.calTotal();
        }
      }).finally(() => this.loadingData = false);
    }
  }


  staffData: any;
  getData2() {
    let a = this.basicForm?.apiPayload();
    this.staffData = a.patient_fk_id;
    console.log(this.staffData, "double");
  }
  onKey() {
    const treatment = this.basicForm?.apiPayload();
    if (this.basicForm?.isValid()) {
      this.subBtn = true;
    } else {
      this.subBtn = false;
    }
  }

  tblAction = (id: string | number, type: tableAction, data: any, index): Promise<any> => {
    switch (type) {
      case 'DELETE':
        if (data.id) {
          this.treatmentList[index].action = 3;
        } else if (this.treatmentList[index]) {
          this.treatmentList.splice(index, 1);
        }
        this.calTotal();
        this.basicForm?.reset();
        this.tableData?.reload();
        break;
    }
    return Promise.resolve(true);
  };

  addTreatment() {
    console.log('working', this.basicForm);
    let a = this.basicForm?.apiPayload();
    a.patient_fk_id = this.invoiceData?.patient_fk_id;
    this.treatmentList.push(a);
    console.log('treat', a);
    this.calTotal();
    this.basicForm?.reset();
    this.subBtn = false;
    this.tableData?.reload();
  }

  calTotal() {
    this.totalAmount = 0;
    this.treatmentList.forEach((e: any) => {
      if (e.action !== 3) {
        const amount = parseInt(e.amount) || 0;
        this.totalAmount += amount;
      }
    });
    const discount = +this.paymentForm.value.discount;
    this.discountAmount = this.invoiceData?.discount || 0;
    console.log('discount', this.discountAmount);

    const payment = +this.paymentForm.value.payment || 0;
    this.totalPaid = this.invoiceData?.total_paid_amount || 0;
    this.overallAmount = this.totalAmount;
    this.finalAmount = this.overallAmount - discount;
    console.log('final amout', this.finalAmount);

    this.discountAmount = this.invoiceData.discount || 0;
    this.finalViewAmount = this.overallAmount - this.discountAmount
    this.paymentShow = payment;
    // this.dueAmount = this.finalAmount
    this.dueAmountRemain = this.finalAmount - payment;
    this.pendingAmount = this.finalAmount - this.totalPaid
    this.balanceAmt = this.finalViewAmount - this.totalPaid
  }

  calTotalByMakePayment() {
    // this.dueAmount = this.finalViewAmount - (this.invoiceData?.total_paid_amount || 0) - (+this.paymentForm.value.payment || 0);
    this.dueAmount = (this.finalAmount - this.invoiceData.total_paid_amount) - (+this.paymentForm.value.payment || 0);
    // console.log('this.finalAmount', this.finalAmount);
    // console.log('total_paid_amount', this.invoiceData.total_paid_amount);
    // console.log('+this.paymentForm.value.payment', +this.paymentForm.value.payment);
    // console.log('due amount', this.dueAmount)
    if (this.dueAmount == 0) {
      this.paidShowBtn = "Fully Paid"
    } else if (this.dueAmount < 0) {
      this.paidShowBtn = "Exceed Payment"
    } else {
      this.paidShowBtn = 'Not fully paid'
    }
  }

  apiPayload() {
    //payload
    const payload = this.paymentForm.value;
    if (this.invoiceId) {
      payload.id = this.invoiceId
    }
    payload.patient_fk_id = this.invoiceId ? this.invoiceData.patient_fk_id : this.invoiceData.id
    payload.total_amount = this.totalAmount;
    payload.final_amount = (this.totalAmount - (payload.discount || 0));
    if (this.mode == 'EDIT' && this.invoiceId) {
      payload.final_amount = this.finalViewAmount
    }
    payload.pay_amount = this.paymentForm.value.payment || 0
    payload.payment_date = this.paymentForm.value.payment_date || ''
    payload.item = this.treatmentList;
    payload.discount = this.paymentForm.value.discount
    if (this.mode == 'EDIT' && this.invoiceId) {
      payload.discount = this.discountAmount
    }
    payload.pay_ref_number = this.invoiceData?.mobile_no
    return payload;
  }

  private formatDateForInput(dateValue: string | Date) {
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) {
      return '';
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }


  loading: boolean = false;

  submit() {
    // if (this.dueAmount < 0) {
    //   this.alertService.showToast('Due Amount should not be lesser than zero', 'warn');
    //   return;
    // }

    const paymentValue = this.paymentForm.get('payment')?.value;
    if (!paymentValue || paymentValue <= 0) {
      this.alertService.showToast('Please enter a valid payment amount', 'warn');
      return;
    }

    if (paymentValue > this.balanceAmt) {
      this.alertService.showToast('Payment amount should not exceed ', 'warn');
      return;
    }

    if (!this.paymentForm.valid) {
      this.alertService.showToast('Not valid, please check amount and discount', 'warn');
      return;
    }
    const payload = this.apiPayload();
    if (!isArray(payload.item) || payload.item.length === 0) {
      this.alertService.showToast('Please add invoice description to the table', 'info');
      return;
    }
    const successMsg = this.invoiceId ? 'Successfully Updated' : 'Successfully Saved';
    const errorMsg = this.invoiceId ? 'Unable to Update' : 'Unable to Save';

    this.loading = true;
    this.invoiceApi.saveInvoice(payload)
      .then(async (res: ResponseData) => {
        if (res.statusCode === RESPONSE_CODE.SUCCESS) {
          this.alertService.showToast(successMsg, 'success');
          this.router.navigate([UrlServices.PAGE_URL.INVOICE.LIST.URL]);

          if (res.result?.docContent) {
            this.printInvoice(res.result.docContent);
          }

          // this.close();
        } else {
          this.alertService.showToast(errorMsg, 'error');
        }
      })
      .catch(() => {
        this.alertService.showToast('Something went wrong. Please try again.', 'error');
      })
      .finally(() => {
        this.loading = false;
      });
  }


  getTreatmentData = async (e: tblFilterQuery): Promise<any> => {
    return this.treatmentList.filter(a => a?.action != 3);
  };

  getInvoicePayment() {
    if (this.invoiceId) {
      this.invoiceApi.invoiceGetDetails(this.invoiceId).then((res: ResponseData | any) => {
        if (res?.statusCode == RESPONSE_CODE.SUCCESS) {
          this.paymentData = res.result
        }
      })
    }
  }

  printInvoice(invoiceId: any) {
    this.loading = true;
    this.patientApi.patientInvoicePrint(invoiceId).then((res: ResponseData) => {
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        const invoiceHtml = res.result?.html;

        const modalData: any = {
          eventName: 'INVOICE',
          id: invoiceId,
          htmlContent: invoiceHtml
        };

        this.modalService.openModal(PrintDocComponent, modalData, 'modal-lg', 2);
      }
    }).finally(() => {
      this.loading = false;
    });
  }


  onChange(e: any) {
    if (e.controlName == 'patient_fk_id' && e?.event?.value) {
      this.getInvoiceData(e.event.value.patient_fk_id);
    }
  }
  close(status = true) {
    if (this.isModal) {
      this._bsModalRef.hide();
      this.onClose.next({ reload: status })
    } else {
      this.navServe.goTo(UrlServices.DASHBOARD_ROUTE, {})
      // this.navServe.back();
    }
  }
}
